import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import Text from "components/atoms/Text";
import CheckboxField from "components/molecules/CheckboxField";
import { Space } from "antd";
import { networkOptions } from "../utils/options";
import TableField from "components/molecules/TableField";
import DateField from "components/molecules/DateField";
import TableMenu from "components/molecules/TableMenu";
import { autoFillOutOfNetworkCoverage } from "../utils/table";
import { useLocation } from "react-router-dom";
import { tierCodesOptions, tierNamesOptions, pharmacyTypesOptions, maxSupplyOptions } from "../utils/options";

const columns = (handleOnChangeNumberOfTiers, handleOnChangeNumberOfPharmacies) =>
  [
    {
      title: "",
      dataIndex: "idx",
      width: 22.5,
      editable: false,
      fixed: "left",
    },
    {
      title: "Pharmacy Benefit Manager Name",
      dataIndex: "name",
      width: 100,
      editable: true,
      inputType: "text",
      shouldCellUpdate: () => false,
      disabled: true,
    },
    {
      title: "Number of Tiers",
      dataIndex: "numberOfTiers",
      width: 50,
      editable: true,
      inputType: "select",
      dropdownMatchSelectWidth: 200,
      options: Object.keys(tierCodesOptions).map((key) => ({ value: Number(key), name: key })),
      handleOnSelect: handleOnChangeNumberOfTiers,
      shouldCellUpdate: () => false,
    },
    {
      title: "Tier Codes",
      dataIndex: "tierCodes",
      width: 50,
      editable: true,
      inputType: "tierCodes",
      options: tierCodesOptions,
      shouldCellUpdate: (record, prevRecord) => {
        return record.numberOfTiers !== prevRecord.numberOfTiers;
      },
    },
    {
      title: "Tier Names",
      dataIndex: "tierNames",
      width: 200,
      editable: true,
      inputType: "tierNames",
      options: tierNamesOptions,
      shouldCellUpdate: (record, prevRecord) => {
        return record.numberOfTiers !== prevRecord.numberOfTiers;
      },
    },
    {
      title: "Types of Pharmacies",
      dataIndex: "typesOfPharmacies",
      width: 25,
      editable: true,
      inputType: "select",
      dropdownMatchSelectWidth: 200,
      options: Object.keys(pharmacyTypesOptions).map((key) => ({ value: Number(key), name: key })),
      handleOnSelect: handleOnChangeNumberOfPharmacies,
      shouldCellUpdate: () => false,
    },
    {
      title: "Type",
      dataIndex: "pharmacyTypes",
      width: 200,
      editable: true,
      disabled: true,
      inputType: "pharmacyTypes",
      options: pharmacyTypesOptions,
      shouldCellUpdate: (record, prevRecord) => {
        return record.typesOfPharmacies !== prevRecord.typesOfPharmacies;
      },
    },
    {
      title: "Maximum Supply",
      dataIndex: "maxSupply",
      width: 100,
      editable: true,
      disabled: true,
      inputType: "maxSupply",
      options: maxSupplyOptions,
      shouldCellUpdate: (record, prevRecord) => {
        return record.typesOfPharmacies !== prevRecord.typesOfPharmacies;
      },
    },
    {
      title: "",
      key: "operation",
      fixed: "right",
      width: 62,
    },
  ].map((col) => {
    return {
      ...col,
      onCell: (_, idx) => ({
        index: idx,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        inputType: col.inputType,
        options: col.options,
        dropdownMatchSelectWidth: col.dropdownMatchSelectWidth,
        disabled: col.disabled || false,
        emptyValue: col.emptyValue,
        handleOnSelect: col.handleOnSelect || null,
        handleOnChange: col.handleOnChange || null,
      }),
    };
  });

const Step = () => {
  const { state } = useLocation();
  const { values, setErrors, setTouched, setFieldValue } = useFormikContext();
  const { table, pharmacyManagersTable } = values;

  useEffect(() => {
    document.getElementById("form-content").scrollTo({ top: 0, behavior: "smooth" });
    setErrors({});
    setTouched({}, false);
  }, []);

  const handleOnChangeNumberOfTiers = (value, index) => {
    const currentItem = values.pharmacyManagersTable[index];

    const updatedItem = {
      ...currentItem,
      numberOfTiers: value,
      tierCodes: tierCodesOptions[value],
      tierNames: tierNamesOptions[value],
    };
    setFieldValue(`pharmacyManagersTable.${index}`, updatedItem);
  };

  const handleOnChangeNumberOfPharmacies = (value, index) => {
    const currentItem = pharmacyManagersTable[index];
    const updatedItem = {
      ...currentItem,
      typesOfPharmacies: value,
      pharmacyTypes: pharmacyTypesOptions[value],
      maxSupply: maxSupplyOptions[value],
    };
    updatedItem.planList.forEach((planLabel) => {
      const planObj = table.find((plan) => plan.label === planLabel);
      const updatedPlan = {
        ...planObj,
        pharmacyTypes: pharmacyTypesOptions[value],
      };
      setFieldValue(`table.${table.indexOf(planObj)}`, updatedPlan);
    });
    setFieldValue(`pharmacyManagersTable.${index}`, updatedItem);
  };

  return (
    <>
      <Text sectionTitle>Tier Codes and Tier Names</Text>
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <TableField
          name="pharmacyManagersTable"
          columns={columns(handleOnChangeNumberOfTiers, handleOnChangeNumberOfPharmacies)}
          dataSource={pharmacyManagersTable}
          tableLayout="fixed"
        />
      </Space>
    </>
  );
};

export default Step;
